/**
 * AuthImg — renders an image served by /api/files/{id} preserving cookie auth.
 *
 * Uses `crossOrigin="use-credentials"` so the browser sends our session cookie
 * cross-origin (CORS already allows credentials backend-side).
 *
 * Props:
 *   - fileId: string                — file_id to fetch
 *   - alt?: string
 *   - className?: string
 *   - onError?: () => void
 */
import React from "react";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function AuthImg({ fileId, alt = "", className, onError, ...rest }) {
  if (!fileId) return null;
  return (
    <img
      src={`${API_BASE}/api/files/${fileId}`}
      crossOrigin="use-credentials"
      alt={alt}
      loading="lazy"
      className={className}
      onError={onError}
      {...rest}
    />
  );
}
